module.exports = __webpack_public_path__ + "static/squares-top-d8c74b8fa8ed3239a8d23292b7918403.png";